import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_BK_URL = "http://localhost:8082/gateway/finance/Banque"
// const BASE_BK_URL = "http://192.168.1.112:8082/gateway/finance/Banque"

class ProductService {
  addNewProduct(productModel) {
    return api.post(UtilsUrl.productURL() + "/addProduct", productModel);
  }
  addMarketingProduct(productModel) {
    return api.put(
      UtilsUrl.productURL() + "/marketingUpdateProduct",
      productModel
    );
  }
  addSpecificity2Product(productModel) {
    return api.post(
      UtilsUrl.productURL() + "/addSpecificity2Product",
      productModel
    );
  }
  getAllSkuFamily(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllSkuFamily/" +
      idUserCreation +
      "/" +
      isDeleted
    );
  }
  getDevisOfLastMonth(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.documentURL() +
      "/getDevisOfLastMonth/" +
      idUserCreation +
      "/" +
      isDeleted
    );
  }
  getAllProductsOnPurshase(idUserCreation, serialNumber) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllProductsOnPurshase/" +
      idUserCreation +
      "/" +
      serialNumber
    );
  }
  getAllProductsOnPurshaseAndService(idUserCreation, onPurchase, service) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllProductsOnPurshaseAndService/" +
      idUserCreation +
      "/" +
      onPurchase +
      "/" +
      service
    );
  }
  getAllProductsOnSaleAndWarehouse(idUserCreation, onSale, idWarehouse) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllProductsOnSaleAndWarehouse/" +
      idUserCreation +
      "/" +
      onSale +
      "/" +
      idWarehouse
    );
  }
  getAllSkuCategory(idUserCreation, isDeleted) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllSKUCategory/" +
      idUserCreation +
      "/" +
      isDeleted
    );
  }
  getAllCategoriesBySubFamilyId(idUserCreation, subFamilyId) {
    return api.get(
      UtilsUrl.productURL() +
      "/getCategoryBySubFamilyId/" +
      idUserCreation +
      "/" +
      subFamilyId
    );
  }
  getAllProductsByFilters(filterModel) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllProductsByFilters/" +
      filterModel.idUser +
      "/" +
      filterModel.isDeleted +
      "/" +
      filterModel.brandId +
      "/" +
      filterModel.categoryId +
      "/" +
      filterModel.dateDebut +
      "/" +
      filterModel.dateFin +
      "/" +
      filterModel.codearticle
    );
  }
  // params: { page, size, isDeleted, brandId, categoryId, dateDebut, dateFin, productCode, search }
  // dateDebut / dateFin format: yyyy-MM-dd'T'HH:mm:ss
  getProductsPage(idUser, params = {}) {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        cleanParams[key] = value;
      }
    });
    return api.get(UtilsUrl.productURL() + "/getProductsPage/" + idUser, {
      params: cleanParams,
    });
  }
  // paginated lists: kind = "Families" | "SubFamilies" | "Categories" | "Brands"
  // params: { page, size, isDeleted, search }
  getReferencePage(kind, params = {}) {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== "") {
        cleanParams[key] = value;
      }
    });
    return api.get(
      UtilsUrl.productURL() + "/get" + kind + "Page/" + currentUserId(),
      { params: cleanParams }
    );
  }
  // kind = "Family" | "SubFamily" | "Category" | "Brand"
  archiveOrRestoreReference(kind, id, isDeleted) {
    return api.post(
      UtilsUrl.productURL() +
        "/deleteAndRestore" +
        kind +
        "/" +
        currentUserId() +
        "/" +
        id +
        "/" +
        isDeleted
    );
  }
  getProductById(idUser, id) {
    return api.get(
      UtilsUrl.productURL() + "/getProductById/" + idUser + "/" + id
    );
  }
  addProductSubFamily(productSubFamilyModel) {
    return api.post(
      UtilsUrl.productURL() + "/addProductSubFamily",
      productSubFamilyModel
    );
  }

  addProductFamily(productModel) {
    return api.post(UtilsUrl.productURL() + "/addProductFamily", productModel);
  }
  addProductCategory(prodCategoryModel) {
    return api.post(
      UtilsUrl.productURL() + "/addProductCategory",
      prodCategoryModel
    );
  }

  getProductByFamily(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductByFamily/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductBySubFamily(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductBySubFamily/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductByCategory(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductByCategory/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductByBrand(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductByBrand/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  addBrand(brandModel) {
    return api.post(UtilsUrl.productURL() + "/addProductBrand", brandModel);
  }
  updatePriceDocument(idUser, reference, typeDocument, newPriceHTC, newPriceTTC) {
    return api.get(
      UtilsUrl.documentURL() +
      "/updatePriceFacture/" +
      idUser +
      "/" +
      typeDocument +
      "/" +
      reference +
      "/" +
      newPriceHTC +
      "/" +
      newPriceTTC
    );
  }

  updateBrand(idUserCreation, idBrand, newName, newDescription) {
    return api.post(
      UtilsUrl.productURL() +
      "/updateBrand/" +
      idUserCreation +
      "/" +
      idBrand +
      "/" +
      newName +
      "/" +
      newDescription
    );
  }
  updateFamily(idUserCreation, idFamily, newName, newDescription) {
    return api.post(
      UtilsUrl.productURL() +
      "/updateFamily/" +
      idUserCreation +
      "/" +
      idFamily +
      "/" +
      newName +
      "/" +
      newDescription
    );
  }
  updateSubFamily(idUserCreation, idsubFamily, newName, newDescription) {
    return api.post(
      UtilsUrl.productURL() +
      "/updateSubFamily/" +
      idUserCreation +
      "/" +
      idsubFamily +
      "/" +
      newName +
      "/" +
      newDescription
    );
  }
  updateCategory(idUserCreation, idCategory, newName, newDescription) {
    return api.post(
      UtilsUrl.productURL() +
      "/updateCategory/" +
      idUserCreation +
      "/" +
      idCategory +
      "/" +
      newName +
      "/" +
      newDescription
    );
  }
  getFamilyById(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getFamilyById/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductSubFamilyById(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductSubFamilyById/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductCategoryById(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductSubFamilyById/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getBrandById(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() + "/getBrandById/" + idUserCreation + "/" + idFamily
    );
  }
  getCategoryById(idUserCreation, idFamily) {
    return api.get(
      UtilsUrl.productURL() +
      "/getCategoryById/" +
      idUserCreation +
      "/" +
      idFamily
    );
  }
  getProductByCode(idUserCreation, codeArticle) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductByCode/" +
      idUserCreation +
      "/" +
      codeArticle
    );
  }
  getProductByBarCode(idUserCreation, barcode) {
    return api.get(
      UtilsUrl.productURL() +
      "/getProductByBarCode/" +
      idUserCreation +
      "/" +
      barcode
    );
  }
  getLastProductPurchasePrice(idUserCreation, idProduct) {
    return api.get(
      UtilsUrl.productURL() +
      "/getLastProductPurchasePrice/" +
      idUserCreation +
      "/" +
      idProduct
    );
  }
  getAllProductsOnPurshaseAndServiceUsingSearch(idUserCreation, onPurchase, service, searchData) {
    return api.get(
      UtilsUrl.productURL() +
      "/getAllProductsOnPurshaseAndServiceUsingSearch/" +
      idUserCreation +
      "/" +
      onPurchase +
      "/" +
      service +
      "/" +
      searchData
    );
  }

  searchProducts(idUserCreation, searchData) {
    return api.get(
      UtilsUrl.productURL() +
      "/searchProducts/" +
      idUserCreation, {
      params: {
        search: searchData,
      }
    },
  );
  }


}

export default new ProductService();
